export enum OrcamentoStatus {
  EM_ELABORACAO = 'Em elaboração',
  EM_ANALISE = 'Em análise',
  FATURADO = 'Faturado',
  FATURADO_COM_AJUSTE = 'Faturado com ajuste',
  CANCELADO = 'Cancelado',
  CANCELADO_PAGO = 'Cancelado Pago',
  AGUARDANDO_COMERCIAL = 'Aguardando Comercial',
  AGUARDANDO_PAGAMENTO = 'Aguardando Pagamento',
  PAGAMENTO_REALIZADO = 'Pagamento Realizado',
  PAGO_PARCIALMENTE = 'Pago Parcialmente',
  EXCLUIDO = 'Excluído',
  INTERNAL_ERROR = 'Internal Error',
  EM_EDICAO = 'Em Edição',
  LIMITE_NAO_ATINGINDO = 'Lim. Não Atingido'
}